import { useState, useEffect } from "react";

export default function Weather() {
  const [weather, setWeather] = useState([null, null]);

  useEffect(() => {
    const fetchWeatherData = async () => {
      const date = new Date();
      const getTime = date.toLocaleTimeString("hu-HU", {
        hour: "2-digit",
        minute: "2-digit",
      });
      const hour = parseInt(getTime.slice(0, 2), 10);

      const fetchCityWeather = async (latitude, longitude) => {
        const res = await fetch(
          `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&hourly=temperature_2m,rain,snowfall&timezone=Europe%2FBerlin&forecast_days=1`,
        );
        const data = await res.json();
        const temp = Math.floor(data.hourly.temperature_2m[hour - 1]);
        if (temp < 10) return `🥶 ${temp}°C,`;
        else if (temp < 15) return `☁️ ${temp}°C,`;
        else if (temp < 20) return `🌥️ ${temp}°C,`;
        else if (temp < 25) return `☀️ ${temp}°C,`;
        else if (temp < 30) return `🌞 ${temp}°C,`;
        else if (temp >= 30) return `🥵 ${temp}°C,`;
        else return `${temp}°C`;
      };

      const [budapestWeather, maltaWeather] = await Promise.all([
        fetchCityWeather(47.4984, 19.0404),
        fetchCityWeather(35.9167, 14.4333),
      ]);

      setWeather([budapestWeather, maltaWeather]);
    };

    fetchWeatherData();

    const interval = setInterval(fetchWeatherData, 20 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="weather flex flex-row gap-4">
      <div>{weather[1]} Malta</div>
    </div>
  );
}
